import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { Room } from '../../../../../models/hotel-room-types';
import { RoomInfo } from '../RoomInfo';
import { RoomFacilities } from '../RoomFacilities';

import { RoomGallery } from '../RoomGallery';

export interface RoomInfoContentProps {
    room: Room;
}
interface StyledRoomInfoContentProps
    extends RoomInfoContentProps,
        JSSClassesProps<ComponentJSSClasses> {}

export const RoomInfoContent = ({
    room,
    classes,
}: StyledRoomInfoContentProps) => {

    return (
        <div className={classes.roomInfoContent}>
            <div className={classes.infoRow}>
                <RoomGallery photos={room.photos} room={room} />
                <RoomInfo room={room} />
            </div>
            <RoomFacilities room={room} />
        </div>
    );
};
